// App.js - UPDATED VERSION WITH SCROLL TO TOP
import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Quick from './Pages/Quick';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Privacy from './Pages/Privacy';
import Cart from './Pages/Cart';
import Terms from './Pages/Terms';
import ShippingPolicy from './Pages/ShippingPolicy';
import Thanks from './Pages/Thanks';
import ScrollToTop from './Components/ScrollToTop'; // Import the component
import Invoice from './Pages/Invoice';

function App() {
  return (
    <Router basename='/'>
      <ScrollToTop /> {/* Add this here */}
      <Routes>
        <Route path="/" element={<Quick />} />
        <Route path='/home' element={<Home />} />
        <Route path='/quick' element={<Quick />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/shippingpolicy' element={<ShippingPolicy />} />
        <Route path='/thanks' element={<Thanks />} />
        <Route path='/invoice' element={<Invoice />} />
      </Routes>
    </Router>
  );
}

export default App;